"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferFlags = void 0;
var OfferFlags;
(function (OfferFlags) {
    OfferFlags[OfferFlags["lsfPassive"] = 65536] = "lsfPassive";
    OfferFlags[OfferFlags["lsfSell"] = 131072] = "lsfSell";
})(OfferFlags = exports.OfferFlags || (exports.OfferFlags = {}));
//# sourceMappingURL=Offer.js.map